import script from "./MensajeWhatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./MensajeWhatsapp.vue?vue&type=script&setup=true&lang=js"

import "./MensajeWhatsapp.vue?vue&type=style&index=0&id=61a2dc8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a2dc8c"]])

export default __exports__